import { render } from "./ScholarshipView.vue?vue&type=template&id=f5c3a1d8"
import script from "./ScholarshipView.vue?vue&type=script&lang=js"
export * from "./ScholarshipView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__